module.exports = __webpack_public_path__ + "static/media/Team-work-Illustration.32509877.svg";